// FilterBarContainer.jsx for Professor Dashboard!

import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import institutionOptions from '../data/institution_options.json';

// Use the same majors options that students use in their profile
const majorsOptions = [
  { value: 'computer-science', label: 'Computer Science' },
  { value: 'electrical-engineering', label: 'Electrical Engineering' },
  { value: 'mechanical-engineering', label: 'Mechanical Engineering' },
  { value: 'civil-engineering', label: 'Civil Engineering' },
  { value: 'chemical-engineering', label: 'Chemical Engineering' },
  { value: 'biomedical-engineering', label: 'Biomedical Engineering' },
  { value: 'aerospace-engineering', label: 'Aerospace Engineering' },
  { value: 'industrial-engineering', label: 'Industrial Engineering' },
  { value: 'materials-science', label: 'Materials Science' },
  { value: 'nuclear-engineering', label: 'Nuclear Engineering' },
  { value: 'environmental-engineering', label: 'Environmental Engineering' },
  { value: 'physics', label: 'Physics' },
  { value: 'chemistry', label: 'Chemistry' },
  { value: 'biology', label: 'Biology' },
  { value: 'mathematics', label: 'Mathematics' },
  { value: 'statistics', label: 'Statistics' },
  { value: 'economics', label: 'Economics' },
  { value: 'psychology', label: 'Psychology' },
  { value: 'sociology', label: 'Sociology' },
  { value: 'political-science', label: 'Political Science' },
  { value: 'history', label: 'History' },
  { value: 'philosophy', label: 'Philosophy' },
  { value: 'english', label: 'English' },
  { value: 'literature', label: 'Literature' },
  { value: 'linguistics', label: 'Linguistics' },
  { value: 'art-history', label: 'Art History' },
  { value: 'music', label: 'Music' },
  { value: 'theater', label: 'Theater' },
  { value: 'film-studies', label: 'Film Studies' },
  { value: 'architecture', label: 'Architecture' },
  { value: 'urban-planning', label: 'Urban Planning' },
  { value: 'landscape-architecture', label: 'Landscape Architecture' },
  { value: 'other', label: 'Other' }
];

// Countries data for dropdown (same as student profile)
const countriesOptions = [
  { value: 'United States', label: 'United States' },
  { value: 'Canada', label: 'Canada' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'Germany', label: 'Germany' },
  { value: 'France', label: 'France' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Finland', label: 'Finland' },
  { value: 'Austria', label: 'Austria' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'Australia', label: 'Australia' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Japan', label: 'Japan' },
  { value: 'South Korea', label: 'South Korea' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Hong Kong', label: 'Hong Kong' },
  { value: 'Israel', label: 'Israel' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Greece', label: 'Greece' },
  { value: 'Poland', label: 'Poland' },
  { value: 'Czech Republic', label: 'Czech Republic' },
  { value: 'Hungary', label: 'Hungary' },
  { value: 'Estonia', label: 'Estonia' },
  { value: 'Latvia', label: 'Latvia' },
  { value: 'Lithuania', label: 'Lithuania' },
  { value: 'Slovenia', label: 'Slovenia' },
  { value: 'Slovakia', label: 'Slovakia' },
  { value: 'Croatia', label: 'Croatia' },
  { value: 'Romania', label: 'Romania' },
  { value: 'Bulgaria', label: 'Bulgaria' },
  { value: 'Cyprus', label: 'Cyprus' },
  { value: 'Malta', label: 'Malta' },
  { value: 'Luxembourg', label: 'Luxembourg' },
  { value: 'Iceland', label: 'Iceland' },
  { value: 'Liechtenstein', label: 'Liechtenstein' },
  { value: 'Monaco', label: 'Monaco' },
  { value: 'San Marino', label: 'San Marino' },
  { value: 'Vatican City', label: 'Vatican City' },
  { value: 'Andorra', label: 'Andorra' },
  { value: 'Puerto Rico', label: 'Puerto Rico' },
  { value: 'Afghanistan', label: 'Afghanistan' },
  { value: 'Albania', label: 'Albania' },
  { value: 'Armenia', label: 'Armenia' },
  { value: 'Azerbaijan', label: 'Azerbaijan' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
  { value: 'Cambodia', label: 'Cambodia' },
  { value: 'Cameroon', label: 'Cameroon' },
  { value: 'Côte d\'Ivoire', label: 'Côte d\'Ivoire' },
  { value: 'Democratic Republic of the Congo', label: 'Democratic Republic of the Congo' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Guatemala', label: 'Guatemala' },
  { value: 'Iraq', label: 'Iraq' },
  { value: 'Iran', label: 'Iran' },
  { value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
  { value: 'Laos', label: 'Laos' },
  { value: 'Libya', label: 'Libya' },
  { value: 'Macedonia', label: 'Macedonia' },
  { value: 'Moldova', label: 'Moldova' },
  { value: 'Mongolia', label: 'Mongolia' },
  { value: 'Myanmar', label: 'Myanmar' },
  { value: 'Nepal', label: 'Nepal' },
  { value: 'North Korea', label: 'North Korea' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Palestine', label: 'Palestine' },
  { value: 'Serbia', label: 'Serbia' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Sudan', label: 'Sudan' },
  { value: 'Syria', label: 'Syria' },
  { value: 'Tajikistan', label: 'Tajikistan' },
  { value: 'Turkmenistan', label: 'Turkmenistan' },
  { value: 'Yemen', label: 'Yemen' }
];

export default function FilterBarContainer({ onFilterChange }) {
  const [filters, setFilters] = useState({
    name: '',
    interests: '',
    institutions: [],
    gpa: [0, 4],
    fields: [],
    preferredCountries: [],
  });

  useEffect(() => {
    onFilterChange(filters);
  }, [filters, onFilterChange]);

  return (
    <div className="w-full md:w-64 bg-white p-4 rounded-lg shadow-md space-y-4">
      <h2 className="text-xl font-bold font-poppins mb-2">Filter Students</h2>

      {/* Name Search */}
      <div>
        <label className="block text-sm font-medium font-nunito mb-1">Search by Name</label>
        <input
          type="text"
          value={filters.name}
          onChange={(e) => setFilters({ ...filters, name: e.target.value })}
          className="w-full p-2 border rounded-lg font-nunito"
          placeholder="e.g., John Doe"
        />
      </div>

      {/* Interests Search */}
      <div>
        <label className="block text-sm font-medium font-nunito mb-1">Search by Interest</label>
        <input
          type="text"
          value={filters.interests}
          onChange={(e) => setFilters({ ...filters, interests: e.target.value })}
          className="w-full p-2 border rounded-lg font-nunito"
          placeholder="e.g., Machine Learning"
        />
      </div>

      {/* Institution Select */}
      <div>
        <label className="block text-sm font-medium font-nunito mb-1">Institutions</label>
        <Select
          isMulti
          options={institutionOptions}
          value={institutionOptions.filter(opt => filters.institutions.includes(opt.value))}
          onChange={(selectedOptions) => {
            const selectedValues = selectedOptions.map(opt => opt.value);
            setFilters({ ...filters, institutions: selectedValues });
          }}
          className="basic-multi-select font-nunito"
          classNamePrefix="select"
          placeholder="Select institutions..."
        />
      </div>

      {/* GPA Range Filter with Input + Slider */}
        <div>
        <label className="block text-sm font-medium font-nunito mb-1">
            GPA Range: {filters.gpa[0]} - {filters.gpa[1]}
        </label>
        <p className="text-xs text-gray-500 mb-2">
            Adjust with sliders or type directly.
        </p>

        {/* Input fields for min and max */}
        <div className="flex space-x-2 mb-2">
            <input
            type="number"
            min="0"
            max="100"
            step="0.1"
            value={filters.gpa[0]}
            onChange={(e) => {
                let val = parseFloat(e.target.value);
                if (isNaN(val)) val = 0;
                if (val > filters.gpa[1]) val = filters.gpa[1]; // Prevent invalid ranges
                setFilters({ ...filters, gpa: [val, filters.gpa[1]] });
            }}
            className="w-1/2 p-2 border rounded-lg font-nunito"
            placeholder="Min GPA"
            />
            <input
            type="number"
            min="0"
            max="100"
            step="0.1"
            value={filters.gpa[1]}
            onChange={(e) => {
                let val = parseFloat(e.target.value);
                if (isNaN(val)) val = filters.gpa[0];
                if (val < filters.gpa[0]) val = filters.gpa[0]; // Prevent invalid ranges
                setFilters({ ...filters, gpa: [filters.gpa[0], val] });
            }}
            className="w-1/2 p-2 border rounded-lg font-nunito"
            placeholder="Max GPA"
            />
        </div>

        {/* Sliders for min and max */}
        <input
            type="range"
            min="0"
            max="4"
            step="0.1"
            value={filters.gpa[0]}
            onChange={(e) => {
            let val = parseFloat(e.target.value);
            if (val > filters.gpa[1]) val = filters.gpa[1]; // Prevent invalid ranges
            setFilters({ ...filters, gpa: [val, filters.gpa[1]] });
            }}
            className="w-full"
        />
        <input
            type="range"
            min="0"
            max="4"
            step="0.1"
            value={filters.gpa[1]}
            onChange={(e) => {
            let val = parseFloat(e.target.value);
            if (val < filters.gpa[0]) val = filters.gpa[0]; // Prevent invalid ranges
            setFilters({ ...filters, gpa: [filters.gpa[0], val] });
            }}
            className="w-full mt-1"
        />
        </div>



      {/* Department */}
      <div>
        <label className="block text-sm font-medium font-nunito mb-1">Department</label>
        <Select
          isMulti
          options={majorsOptions}
          value={majorsOptions.filter(opt => filters.fields.includes(opt.value))}
          onChange={(selectedOptions) => {
            const selectedValues = selectedOptions.map(opt => opt.value);
            setFilters({ ...filters, fields: selectedValues });
          }}
          className="basic-multi-select font-nunito"
          classNamePrefix="select"
          placeholder="Select departments..."
        />
      </div>

      {/* Preferred Countries */}
      <div>
        <label className="block text-sm font-medium font-nunito mb-1">Preferred Countries</label>
        <Select
          isMulti
          options={countriesOptions}
          value={countriesOptions.filter(opt => filters.preferredCountries.includes(opt.value))}
          onChange={(selectedOptions) => {
            const selectedValues = selectedOptions.map(opt => opt.value);
            setFilters({ ...filters, preferredCountries: selectedValues });
          }}
          className="basic-multi-select font-nunito"
          classNamePrefix="select"
          placeholder="Select countries..."
        />
      </div>
    </div>
  );
}
